import { HTMLControl } from '../controls/html_control.js';
import { window } from '../window.js';

import '../controls/rating_control.js';
import '../controls/image_list.js';
import './review_menu_control.js';
import './review_ratings_view.js';

class ReviewView extends HTMLControl {
  static properties = {
    open: {
      attribute: 'boolean',
      initialize: true,
      set(v) {
        this.detailsElement.open = v;
      },
    },
  };

  set(review) {
    if (this.#reviewPipe) {
      this.#reviewPipe.unpipe();
    }

    this.review = review;

    this.#reviewPipe = this.review.pipe({
      formattedDate: v =>
        (this.visitDateText.textContent = v || `No visit date specified`),
      overallRating: v => (this.overallRating.value = v),
      headline: v => (this.headlineElement.textContent = v),
      text: v => (this.textElement.textContent = v),
      ratingsByGroups: v => this.ratingsView.set(v),
    });

    let picUrls = this.review.thumbnailPicUrls;
    this.imageList.hidden = picUrls.length == 0;
    if (picUrls.length > 0) {
      this.imageList.set(picUrls);
    }
    this.menuElement.setData(this.review);
  }

  static markup = `
    <details>
      <summary>
        <div class='review-summary-container'>
          <div class='review-summary'>
            <rating-control rating-id='overall'
                            readonly></rating-control>
            <div class='review-visit-date'></div>
            <review-menu-control></review-menu-control>
          </div>
          <div class='review-headline'></div>
        </div>
      </summary>
      <div class='review-text'></div>
      <image-list></image-list>
      <review-ratings-view></review-ratings-view>
    </details>
  `;

  static get selectors() {
    return {
      Details: 'details',
      Headline: `.review-headline`,
      ImageList: 'image-list',
      Menu: 'review-menu-control',
      OverallRating: `[rating-id='overall']`,
      RatingsView: 'review-ratings-view',
      Text: '.review-text',
      VisitDateText: `.review-visit-date`,
    };
  }

  static get elements() {
    let s = this.selectors;
    return {
      detailsElement: s.Details,
      headlineElement: s.Headline,
      imageList: s.ImageList,
      menuElement: s.Menu,
      overallRating: s.OverallRating,
      ratingsView: s.RatingsView,
      textElement: s.Text,
      visitDateText: s.VisitDateText,
    };
  }

  #reviewPipe;
}

window.customElements.define('review-view', ReviewView);

export { ReviewView };
